import { FocusMonitor } from '@angular/cdk/a11y';
import { Component, DoCheck, ElementRef, EventEmitter, forwardRef, HostBinding, Injector, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, NgControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldControl, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { Subject, Subscription } from 'rxjs';
import { environment } from '@env/environment';
import { Tenant } from '../../../../core/models/Tenant';


@Component({
  selector: 'app-select-tenants',
  standalone: true,
  imports: [
    MatSelectModule,
    MatIconModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
  ],
  templateUrl: './select-tenants.component.html',
  styleUrl: './select-tenants.component.scss',
  providers: [
    { provide: MatFormFieldControl, useExisting: SelectTenantsComponent },
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SelectTenantsComponent),
    }
  ],
})
export class SelectTenantsComponent implements
  OnInit,
  OnDestroy,
  DoCheck,
  MatFormFieldControl<Tenant>,
  ControlValueAccessor {

  lstTenants = environment.tenants;


  @Output()
  tenantValue: EventEmitter<Tenant> = new EventEmitter<Tenant>();

  tenants: Tenant[];
  _cachedData: Tenant[];

  @Input()
  _value: any;

  @Input()
  id: string = 'global-select-tenant-select';
  
  @Input()
  idOptionsPrefix: string = 'global-select-tenant-option-';

  @Input()
  multiple = false;

  @Input()
  includeAllSelector = false;

  @Input()
  filterTenants: string[] = [];

  readonly stateChanges: Subject<void> = new Subject<void>();
  ngControl: NgControl;
  focused: boolean = false;
  empty: boolean;
  required: boolean;
  disabled: boolean;
  errorState = false;
  controlType?: string;
  autofilled?: boolean;
  tenantSuscription$: Subscription;
  focusMonitorSubscription: Subscription;
  touched = false;

  @ViewChild(MatSelect) matSelect: MatSelect;

  @Input()
  get placeholder() {
    return this._placeholder;
  }

  set placeholder(plh) {
    this._placeholder = plh;
    this.stateChanges.next();
  }

  private _placeholder: string;

  @HostBinding('class.floating')
  get shouldLabelFloat() {
    return this.focused || (this.value && Object.keys(this.value).length>0);
  }

  constructor(
    public injector: Injector,
    private focusMonitor: FocusMonitor,
    private elRef: ElementRef
  ) { }

  ngOnInit(): void {
    this.ngControl = this.injector.get(NgControl);
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
    this.tenants = [...this.lstTenants];
    this.focusMonitorSubscription = this.focusMonitor
    .monitor(this.elRef.nativeElement, true)
    .subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });
  }

  sortCompare( a: Tenant, b: Tenant ) {
    if ( a.tenantId < b.tenantId ){
      return -1;
    }
    if ( a.tenantId > b.tenantId ){
      return 1;
    }
    return 0;
  }

  ngDoCheck(): void {
    if (this.ngControl) {
      this.errorState = (this.ngControl.invalid && this.touched) as boolean;
      this.stateChanges.next();
    }
  }
  onChange: any = () => { };

  onTouched: any = () => { };

  updateErrorState(): void { }

  set value(value) {
    this.empty = !value || (value && Object.keys(value).length === 0);
    this._value = value;
    this.tenantValue.emit(value);
    this.onChange(value);
    this.onTouched();
  }

  get value() {
    return this._value;
  }

  writeValue(obj: any): void {
    if (obj == null) {
      this.touched = false;
    }
    if (obj !== undefined) {
      this.value = obj;
      this.stateChanges.next();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  setDescribedByIds(ids: string[]): void { }
  onContainerClick(event: MouseEvent): void { }

  ngOnDestroy(): void {
    this.tenants = [];
    this.tenantSuscription$?.unsubscribe();
    this.focusMonitorSubscription?.unsubscribe();
  }

  handleSelection(selection: any) {
    this.touched = true;
  }

  get allTenants() {
    return this.tenants.map(it => it.tenantId).join(',');
  }
}
